jQuery( function ( $ ) {

  function init () {
    $( 'section.media_and_content' ).each( function () {
      const $section = $(this);
      const $media_wrap = $( '.media-wrap', $section );
      const $graphics = $( '.element', $media_wrap );
      const wrap_rect = $media_wrap.get(0).getBoundingClientRect();
      let min_top = 0;
      let max_bottom = 0;
      let min_left = 0;
      let max_right = 0
      $graphics.each( function () {
        const rect = this.getBoundingClientRect();
        min_top = Math.min( min_top, rect.top - wrap_rect.top );
        max_bottom = Math.max( max_bottom, rect.bottom - wrap_rect.bottom );
        min_left = Math.min( min_left, rect.left - wrap_rect.left );
        max_right = Math.max( max_right, rect.right - wrap_rect.right );
      });
      this.style.setProperty( '--media-graphics-overflow-top', `${ min_top * -1 }px` );
      this.style.setProperty( '--media-graphics-overflow-bottom', `${ max_bottom }px` );
      this.style.setProperty( '--media-graphics-overflow-left', `${ min_left * -1 }px` );
      this.style.setProperty( '--media-graphics-overflow-right', `${ max_right }px` );
    });
  }

  init();
  $( window ).on( 'breakpoint_changed', init );

});